export const RULE_OPTIONS = {
    batak: [],
    spades: [
        // Ten bags cost a hundred (standard); some tables play without the penalty.
        { key: "bagPenalty", kind: "toggle", default: true },
    ],
    tarneeb: [
        // Levant tables lead trump freely; some insist it is broken first, as in Batak.
        { key: "trumpLead", kind: "toggle", default: false },
        // The opening bid: seven (Pagat) or five on more relaxed tables.
        { key: "minBid", kind: "choice", default: 7, choices: [7, 5] },
    ],
    baloot: [
        // Projects (runs and four of a kind) and doubling are the Saudi table's defaults.
        { key: "projects", kind: "toggle", default: true },
        { key: "doubling", kind: "toggle", default: true },
    ],
    king: [],
    // No house rules in the first version (review 0029 decision 217).
    pisti: [],
    hearts: [
        // Omnibus Hearts: whoever takes the jack of diamonds scores ten less.
        { key: "jackOfDiamonds", kind: "toggle", default: false },
    ],
};
export function ruleOptionsFor(family) {
    return RULE_OPTIONS[family];
}
function accepts(option, value) {
    if (option.kind === "toggle")
        return typeof value === "boolean";
    return typeof value === "number" && option.choices.includes(value);
}
/** Known keys with valid values, defaults for the rest; `{}` for a game without options. */
export function normalizeRules(family, raw) {
    const given = typeof raw === "object" && raw !== null ? raw : {};
    const rules = {};
    for (const option of ruleOptionsFor(family)) {
        const value = given[option.key];
        rules[option.key] = accepts(option, value) ? value : option.default;
    }
    return rules;
}
export function ruleToggle(rules, key, fallback) {
    const value = rules?.[key];
    return typeof value === "boolean" ? value : fallback;
}
export function ruleNumber(rules, key, fallback) {
    const value = rules?.[key];
    return typeof value === "number" ? value : fallback;
}
/** Rules that differ from the game's defaults: what a lobby summary should mention. */
export function nonDefaultRules(family, rules) {
    const out = {};
    for (const option of ruleOptionsFor(family)) {
        const value = rules?.[option.key];
        if (value !== undefined && value !== option.default)
            out[option.key] = value;
    }
    return out;
}
//# sourceMappingURL=rules.js.map